import './styles/global.scss';
import '@wix/design-system/styles.global.css';

import { WixDesignSystemProvider } from '@wix/design-system';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { App } from './App';
import { FedopsLoggerProvider } from './common/providers/fedopsLogger';
import { store } from './common/store';
import { fedopsLogger, renderModel } from './util/renderModel';

const { locale, messages } = renderModel.get();
const i18n = initI18n({ locale, messages });

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <FedopsLoggerProvider logger={fedopsLogger}>
      <Provider store={store}>
        <WixDesignSystemProvider features={{ newColorsBranding: true }}>
          <App />
        </WixDesignSystemProvider>
      </Provider>
    </FedopsLoggerProvider>
  </I18nextProvider>,
  document.getElementById('root'),
);

if (!('scrollBehavior' in document.documentElement.style)) {
  import(
    /* webpackChunkName: "smoothscrollPolyfill" */
    './util/smoothscrollPolyfill'
  );
}

window.addEventListener(
  'focus-visible-polyfill-ready',
  () => window.applyFocusVisiblePolyfill(document.body),
  { once: true },
);
